import { Alert, Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Wraps the prototype's registry holder records (holder number, TFN, checks, holdings), which stay
 * sample data until the registry tables exist (milestones 7 and 8).
 */
export default function SampleRecordSection({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Alert
        severity="warning"
        sx={{ mb: 2 }}
        action={
          <Button component={RouterLink} to="/manager/holders" color="inherit" size="small">
            Fides entities
          </Button>
        }
      >
        Sample registry records: fictional holders, checks, beneficial owners and holdings from the
        design prototype. They become real when the registry tables are built.
      </Alert>
      {children}
    </>
  );
}
